import React from 'react'
import { AddTemplateIcon, AddedTemplateIcon, LockTemplateIcon } from '../../../components/common/SvgIcon'

const ProTemplates = ({ proTemplates, isProActive, handleTemplateClick, selectedTemplateId, getTemplateIcon }) => {

  return (
    <div>
      <div className="bg-lgp-body flex items-center gap-2">
        PRO TEMPLATES
        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-[linear-gradient(109.15deg,#7C3BED_0%,#9D26D9_100%)] text-white">
          👑 PRO
        </span>
      </div>
      
      <div className="relative mt-2">
          <div className="space-y-2 max-h-[400px] overflow-y-auto pr-2 custom-scrollbar">
            {proTemplates.map((template) => {
              const isSelected = selectedTemplateId === template.id;
              return (
                <button
                  key={template.id}
                  onClick={() => handleTemplateClick(template.id, template.type)}
                  className={`w-full text-left px-3 py-3 rounded-xl transition flex items-center justify-between group cursor-pointer ${
                    isSelected
                      ? 'bg-[#7C3BED] text-white shadow-md'
                      : 'text-[#17171C] hover:bg-gray-50 border border-transparent hover:border-gray-200'
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <span className="text-xl">{getTemplateIcon(template.name)}</span>
                    <span className={`text-sm font-medium ${isSelected ? 'text-white' : 'text-[#17171C]'}`}>
                      {template.name}
                    </span>
                  </div>

                  <div className="transition-all duration-200">
                    {isSelected ? <AddedTemplateIcon /> : <AddTemplateIcon />}
                  </div>
                </button>
              );
            })}
          </div>
      </div>
    </div>
  )
}

export default ProTemplates